import requestOffers from '../data/requestOffers';
import { saveCurrentFilterValues } from './customFilterSaver';
import { updateDisabledFilter } from './updateDisabledFilter';

import deepEqual from 'fast-deep-equal';

export const setFilterValue = (name, value, skipReload = false, skipDisabledFilterCheck = false) => {
  return async (dispatch, getState: RootStateGetter) => {
    const oldFilterValues = getState().customFilter.filterValues;

    await dispatch({ type: 'SET_FILTER_VALUE', name, value });

    await dispatch(updateDisabledFilter(name, skipDisabledFilterCheck));

    await dispatch(saveCurrentFilterValues());

    // Neu laden, wenn die Filterwerte sich geändert haben
    if (!skipReload && !deepEqual(oldFilterValues, getState().customFilter.filterValues))
      await dispatch(requestOffers(true, true, true));
  };
};
